// extracted by mini-css-extract-plugin
export var createdDate = "_jb-1";
export var divider = "_jb-2";
export var headerDivider = "_jb-3";
export var messagesCard = "_jb-0";
export var messagesContainer = "_jb-6";
export var messagesContainerWrapper = "_jb-4";
export var showLeftPanelButton = "_jb-8";
export var topButtons = "_jb-7";
export var withPadding = "_jb-5";